export const CouponType = {
  VALUE: 1,
  PERCENTAGE: 2,
};
